import React, { useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Layout from "../components/Layout.tsx";
import Login from "../components/login/index.tsx";
import TrainingModal from "../pages/Training/index.tsx";
import UploadDataset from "../pages/DataSet/UploadDataset.tsx";
import CreatePredictor from "../pages/Training/CreatePredictor.tsx";
import FormPrediction from "../pages/Training/FormPrediction.tsx";
import Test from "../components/Test/Test.tsx";
import TemplateList from "../pages/Template/TemplateList.tsx";
import DatasetHeaderManager from "../pages/Template/HeaderManager.tsx";
import ErrorPage from "../components/common/ErrorPage.tsx";
import PreviewDataList from "../pages/DataSet/PreviewList.tsx";
import EditTemplate from "../pages/Template/EditTemplate.tsx";
import TrainPredictor from "../pages/Training/TrainPredictor.tsx";
import FormForecast from "../pages/Training/FormForecast.tsx";
import BatchPrediction from "../pages/Training/BatchPrediction.tsx";
import BatchPredictionView from "../pages/Training/BatchPredictionView.tsx";
import FileListModal from "../pages/DataSet/FileList.tsx";
import FileView from "../pages/DataSet/FileView.tsx";
import DatasetView from "../pages/DataSet/DataSetView.tsx";
import DataList from "../pages/DataSet/DataList.tsx";
import TableGraph from "../components/common/ForecastGraph.tsx";
import ModalDetails from "../pages/Training/ModalDetails.tsx";
import SignIn from "../components/login/signin.tsx";
import Callback from "../components/login/callback.tsx";
import UserProfile from "../components/login/UserProfile.tsx";
import SupersetDashboard from "../pages/Dashboard/Dashboard.tsx";
import NullHandling from "../pages/DataSet/NullHandling.tsx";

interface AppRoutesProps {
  isAuthenticated: boolean;
  setIsAuthenticated: (auth: boolean) => void;
}

const AppRoutes: React.FC<AppRoutesProps> = ({
  isAuthenticated,
  setIsAuthenticated,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/TemplateList" && !sessionStorage.getItem("access_token")) {
      window.opener?.postMessage("requestToken", window.env.REACT_APP_UMP_REDIRECT_URL);

      // Request token from UMP
      const tokenHandler = (event) => {
        if (event.origin === window.env.REACT_APP_UMP_REDIRECT_URL && event.data.token) {
          const { token, refreshToken, redirectedFromUMP, userName } = event.data;
          sessionStorage.setItem("access_token", token || "");
          sessionStorage.setItem("refresh_token", refreshToken || "");
          sessionStorage.setItem("redirectedFromUMP", redirectedFromUMP || "true");
          sessionStorage.setItem("userName", userName || "")
          window.dispatchEvent(new Event("userNameUpdated"));

          try {
            const tokenParts = token.split(".");
            if (tokenParts.length === 3) {
              const decodedPayload = JSON.parse(atob(tokenParts[1]));
              if (decodedPayload?.user_id) {
                sessionStorage.setItem(
                  "user_id",
                  decodedPayload.user_id.toString()
                );
              }
            }
            setIsAuthenticated(true);
            // navigate("/TemplateList");
          } catch (error) {
            console.error("Error decoding access token:", error);
          }
        }
      };

      window.addEventListener("message", tokenHandler);

      return () => {
        window.removeEventListener("message", tokenHandler);
      };
    }
  }, []);

  return (
    <Routes>
      <Route
        path="/signIn"
        element={<SignIn/>}
      />
      <Route
        path="/login/:username"
        element={<Login onLogin={() => setIsAuthenticated(true)} />}
      />
      <Route
        path="/keycloak/callback"
        element={<Callback/>}
      />

      {isAuthenticated ? (
        <>
          <Route
            path="/UploadDataSet"
            element={
              <Layout>
                <UploadDataset />
              </Layout>
            }
          />
          <Route
            path="/fileUpload/:id"
            element={
              <Layout>
                <UploadDataset />
              </Layout>
            }
          />
          <Route
            path="/TrainingModal"
            element={
              <Layout>
                <TrainingModal />
              </Layout>
            }
          />
          <Route
            path="/Dashboard"
            element={
              <Layout>
                <SupersetDashboard />
              </Layout>
            }
          />
          <Route
            path="/CreatePredictor"
            element={
              <Layout>
                <CreatePredictor />
              </Layout>
            }
          />
          <Route
            path="/TrainPredictor"
            element={
              <Layout>
                <TrainPredictor />
              </Layout>
            }
          />
          <Route
            path="/modal-details/:id"
            element={
              <Layout>
                <ModalDetails />
              </Layout>
            }
          />
          <Route
            path="/form-prediction/:id"
            element={
              <Layout>
                <FormPrediction />
              </Layout>
            }
          />
          <Route
            path="/batch-prediction/:id"
            element={
              <Layout>
                <BatchPrediction />
              </Layout>
            }
          />

          <Route
            path="/batch-prediction-view"
            element={
              <Layout>
                <BatchPredictionView />
              </Layout>
            }
          />
          <Route
            path="/forecast/:id"
            element={
              <Layout>
                <FormForecast />
              </Layout>
            }
          />
          <Route
            path="/forecast-result/:id"
            element={
              <Layout>
                <TableGraph/>
              </Layout>
            }
          />
          <Route
            path="/"
            element={
              <Layout>
                <TemplateList />
              </Layout>
            }
          />
          <Route
            path="/TemplateList"
            element={
              <Layout>
                <TemplateList />
              </Layout>
            }
          />
          <Route
            path="/CreateTemplate"
            element={
              <Layout>
                <DatasetHeaderManager />
              </Layout>
            }
          />
          <Route
            path="/Edit-Template/:templateId"
            element={
              <Layout>
                <EditTemplate />
              </Layout>
            }
          />
          <Route
            path="/preview-data"
            element={
              <Layout>
                <PreviewDataList />
              </Layout>
            }
          />
          <Route
            path="/test"
            element={
              <Layout>
                <Test />
              </Layout>
            }
          />
          <Route
            path="/profile"
            element={
              <Layout>
                <UserProfile />
                {/* <></> */}
              </Layout>
            }
          />
          <Route
            path="/Datalist"
            element={
              <Layout>
                <DataList />
              </Layout>
            }
          />
          <Route
            path="/dataset-view/:id"
            element={
              <Layout>
                <DatasetView />
              </Layout>
            }
          />
          <Route
            path="/files/:id"
            element={
              <Layout>
                <FileListModal />
              </Layout>
            }
          />
          <Route
            path="/nullhandling/:id"
            element={
              <Layout>
                <NullHandling />
              </Layout>
            }
          />
          <Route
            path="/view/:id"
            element={
              <Layout>
                <FileView />
              </Layout>
            }
          />
          <Route
            path="*"
            element={
              <Layout>
                <ErrorPage />
              </Layout>
            }
          />
        </>
      ) : (
        <Route path="*" element={<Navigate to="/signIn" replace />} />
      )}
    </Routes>
  );
};

export default AppRoutes;
